type IdLike = string | number;
type MaybeId = { id?: IdLike } | { value?: IdLike } | Record<string, unknown>;

export function extractId(input: unknown): string | null {
  if (typeof input === 'string' || typeof input === 'number') return String(input);
  if (input && typeof input === 'object') {
    const o = input as MaybeId;
    const v = (o as { value?: IdLike }).value;
    if (typeof v === 'string' || typeof v === 'number') return String(v);
    const id = (o as { id?: IdLike }).id;
    if (typeof id === 'string' || typeof id === 'number') return String(id);
  }
  return null;
}

export function normalizeClassIds(classesField: unknown): string[] {
  if (!Array.isArray(classesField)) return [];
  const out = classesField.map(extractId).filter((x): x is string => Boolean(x));
  return Array.from(new Set(out));
}

export function normalizeSiteIds(sitesField: unknown): string[] {
  if (!sitesField) return [];
  if (Array.isArray(sitesField)) {
    const out = sitesField.map(extractId).filter((x): x is string => Boolean(x));
    return Array.from(new Set(out));
  }
  const single = extractId(sitesField);
  return single ? [single] : [];
}
